import { ApolloClient } from '@apollo/client'

import { navigate } from '@redwoodjs/router'

import { fetchViewUuidForRecordsListNavigation } from 'src/fetch/views/fetchViewUuidForRecordsListNavigation'
import { recordsListPathWithViewUuid } from 'src/fetch/views/recordsListViewUrl'

import { TrackedBackgroundJob } from './types'

/**
 * Terminal pill click: navigate staff to the saved table view they started from, then dismiss the pill.
 * Records list only until other job types ship their own navigation helpers.
 */
export const navigateToOriginatingRecordsView = async ({
  apolloClient,
  job,
  organizationId,
  viewUuid: registeredViewUuid,
}: {
  apolloClient: ApolloClient<object>
  job: Pick<TrackedBackgroundJob, 'recordTypeId' | 'viewId'>
  organizationId: number
  /** When captured at job registration, skips the server lookup on pill click. */
  viewUuid?: string
}) => {
  const viewUuid =
    registeredViewUuid ??
    (await fetchViewUuidForRecordsListNavigation({
      apolloClient,
      organizationId,
      recordTypeId: job.recordTypeId,
      viewId: job.viewId,
    }))

  if (!viewUuid) {
    throw new Error(`Could not resolve view uuid for viewId ${job.viewId}`)
  }

  navigate(
    recordsListPathWithViewUuid({
      recordTypeId: job.recordTypeId,
      viewUuid,
    })
  )
}
